export default __webpack_public_path__ + "static/media/file-upload.94fc4143.svg";